import React from "react";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import { makeStyles } from "@material-ui/core/styles";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import YouTubeIcon from "@material-ui/icons/YouTube";
import FacebookIcon from "@material-ui/icons/Facebook";
import PinterestIcon from "@material-ui/icons/Pinterest";
import InstagramIcon from "@material-ui/icons/Instagram";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import DarkLogoWater from "../../assets/images/saw-logo-corrected-water.svg";
// import LightLogo from '../../assets/images/saw-logo-inverse-corrected.svg'
import LightLogo from "../../assets/images/saw-logo-inverse1.svg";
import DarkLogo from "../../assets/images/saw-logo-corrected.svg";
import TexasLogo from "../../assets/images/texas_BaseTry1.svg";
import TexasSVG from "../../assets/images/texasSVG.svg";
import { NavLink } from "react-router-dom";
import { Box, Grid } from "@material-ui/core";

function Copyright() {
  return (
    <Typography variant="body2" color="textPrimary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://dhtradesman.com/">
        DH Tradesman LLC
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
    // backgroundImage: `url(${process.env.PUBLIC_URL + '/DH_logo.png'})`,
    // // transform: "rotate(-20deg)",
    // backgroundRepeat: 'no-repeat',
    padding: theme.spacing(6),
  },
  footerBg: {
    backgroundImage: `url(${process.env.PUBLIC_URL + "/DH_logo.png"})`,
    backgroundRepeat: "no-repeat",
    transform: "rotate(-20deg)",
  },
  alink: {
    textDecoration: "none",
    color: "inherit",
  },
  btnGroup: {
    padding: theme.spacing(2, 0, 1, 0),
  },
  icons: {
    verticalAlign: "middle",
    paddingRight: "5px",
  },
  iconBtn: {
    padding: theme.spacing(2, 0, 0, 0),
    justifyContent: "center",
  },
  verseContainer: {
    padding: theme.spacing(2, 0, 0, 0),
  },
  logoContainer: {
    backgroundImage: DarkLogo,
  },
  watermark: {
    fill: "#000 !important",
  },
}));

const Footer = (props) => {
  let svgColor = props.svgColor;

  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Grid container spacing={3}>
        {/* <Grid item md={4} xs={0} padding={0}
          style={{backgroundImage: `url(${LightLogo})`, 
            backgroundRepeat: 'no-repeat',
            // transform:"rotate(-20deg)",
            padding:'-25px',
            justifyContent:'center',
            justifyItems: 'center',
            align:"center"
          }}
          ></Grid> */}
        {/* <Box clone order={{ xs: 2, sm: 1 }}>
          <Grid item md={4} xs={0}>
            <div align="center">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
                <defs>
                  <linearGradient id="gradient">
                    <stop offset="5%" stop-color="red" />
                    <stop offset="45%" stop-color="white" />
                    <stop offset="95%" stop-color="blue" />
                  </linearGradient>
                </defs>
                <g
                  transform="matrix(1.1373 0 0 1.1373 -6.8421 -6.8837)"
                  clip-path="url(#A)"
                >
                  <g fill={svgColor} fill="url(#gradient)">
                    <path d="M30.199 8.4C28.699 8.4 27.5 9.6 27.5 11.1v30.4H8.801C7.801 41.5 7 42 6.5 42.8s-.5 1.8-.1 2.6c.3.7.8 1.299 1.5 1.799.8.6 1.699 1.501 2.699 2.701 1.2 1.3 2.7 2.9 4.6 4.5 2.8 2.5 2.9 4.699 3 6.799v.5c.2 3.6 8.9 7.201 12 7.201h.4c2.4-.2 3.401-2.7 4.201-4.5.3-.6.599-1.601.799-1.701 0 0 .1-.1.5-.1 1.2 0 3.101.6 3.801.9.1 0 .099 0 .199.1.1 0 3.6 1 5.6 7.1 1.5 4.7 3.802 6.301 5.102 7.301.8.6.799.701.799.801-.1 2.9.9 5.1 2.9 8 1.6 2.4 5.901 3.3 9.801 4 1.3.3 2.598.499 3.398.799.6.2 1.201.301 1.701.301 2.1 0 3.299-1.7 3.299-3.4 0-.2-.099-.499-.199-.699 0 0-1.8-3.601-2.4-7.801-.5-3.4 3.3-7.001 3.6-7.301C77.399 70.499 83.8 66.3 84.9 64c.4-.8 2-.999 3.4-1.199 1.2-.2 2.299-.3 3.199-.9 2.3-1.3 1.799-4 1.199-5.5-.3-1-.3-2.2-.1-2.5 1.3-1.5 1.1-4.601.6-5.801a2.32 2.32 0 0 0-1.1-1.1c-.4-.7-.9-2.301-.9-2.801.1-1.2-.698-2.4-2.398-3.6-.1-1.3-.3-6.299-.5-8.799-.1-1.4-1.301-2.5-2.701-2.5-.7 0-1.899-.401-2.699-.701-.8-1-2.501-2.699-4.301-2.699-.8 0-1.5.299-2 .799-1 .9-2.9 1.4-4 1.4h-.299c-.1 0-.201-.1-.201-.1-.5-.3-1.4-.801-2.6-.801-.5 0-1.099.101-1.699.301-.2.1-.7.199-1.5.199-1.1 0-2.3-.199-2.9-.299l-.1-.1c-.5-.5-1.5-1.301-3-1.301-.7 0-1.3.2-2 .5s-1.2.3-1.4.1c-.7-1.6-2.301-3.199-4.701-2.799-.4.1-.698.1-.898 0l-.5-12.801c-.1-1.5-1.201-2.6-2.701-2.6zm.301 2.799h17.4l.5 12.701c0 .8.4 1.6 1 2 .8.6 2 .8 3.4.6.9-.1 1.4.9 1.5 1.1.1.3.298.501.398.701.4.5 1.301 1.199 2.801 1.199.7 0 1.499-.2 2.199-.5.8-.4 1.101-.2 1.801.4.3.3.701.599 1.301.699.5.1 2.099.4 3.699.4 1 0 1.8-.1 2.5-.4.7-.2.999-.099 1.699.301.2.1.3.199.5.299.4.2.902.301 1.602.301 1.8 0 4.4-.699 6-2.199.3 0 1.1.5 2 1.6.3.3.6.599 1 .799.8.3 2.299.9 3.699 1a193.28 193.28 0 0 1 .4 8.602c0 .8.499 1.6 1.199 2.1.8.5 1.101.9 1.201 1.1 0 1.4.899 4.1 1.799 5.1.2.2.3.3.5.4.1.9.001 2.1-.199 2.5-1.5 1.6-.7 4.701-.6 5.301 0 .1 0 .199.1.199.2.5.5 1.601.1 1.801s-1.299.4-2.199.5c-2.1.3-4.601.698-5.701 2.898-.5 1.1-4.8 4.3-10.1 7.4-.2.1-.3.201-.4.301-.9.8-5.3 5.1-4.6 10 .5 3.8 1.9 7.099 2.4 8.299 0 0 0 .102-.1.102 0 0-.2.098-.9-.102-1-.3-2.201-.598-3.701-.898-2.8-.6-6.998-1.401-7.898-2.801-1.6-2.4-2.5-4.099-2.4-6.199.1-1.8-1.1-2.7-2.1-3.4-1.2-.8-2.8-2.001-4-5.801-2.3-7.2-6.702-8.8-7.602-9.1-.5-.2-2.899-1.1-4.799-1.1-1 0-1.8.199-2.4.699-.8.7-1.299 1.8-1.699 2.9s-1.101 2.6-1.701 2.6h-.1c-2.5 0-8.6-3.199-9-4.299v-.5c-.1-2.4-.2-5.6-4-8.9-1.8-1.6-3.2-3.1-4.4-4.4-1.1-1.2-2.1-2.2-3-2.9l-.299-.299h18.5a2.69 2.69 0 0 0 2.699-2.701z" />
                  </g>
                </g>
              </svg>
              <br />
              <Typography variant="h8" align="center" gutterBottom>
                Texas Strong
              </Typography>
            </div>
          </Grid>
        </Box> */}

        {/* <Box clone order={{ xs: 1, sm: 1 }}> */}
        {/* <Grid item md={4} xs={12}> */}
        <Grid item md={12} xs={12}>
          <Typography variant="h6" align="center" gutterBottom>
            Thank you for supporting local business!
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="textSecondary"
            component="p"
          ></Typography>
          <Copyright />

          <div align="center">
            <CardActions className={classes.iconBtn}>
              <a href="tel://1-254-652-0798" className={classes.alink}>
                <PhoneIcon className={classes.icons} fontSize="large" />
              </a>
              <a href="mailto:Dustin@dhTradesman.com" className={classes.alink}>
                <EmailIcon className={classes.icons} fontSize="large" />
              </a>

              <NavLink
                to="/faq"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ContactSupportIcon
                  className={classes.icons}
                  fontSize="large"
                />
              </NavLink>
            </CardActions>
          </div>

          <div align="center" className={classes.iconContainer}>
            <CardActions className={classes.iconBtn}>
              <a
                href="https://www.facebook.com/DH-Tradesman-LLC-109702414780812"
                target="_blank"
                rel="noreferrer"
                className={classes.alink}
              >
                <FacebookIcon className={classes.icons} fontSize="large" />
              </a>
              <a
                href="https://youtube.com/channel/UCi_9FzbzkLrPERKH-7H_DPQ"
                target="_blank"
                rel="noreferrer"
                className={classes.alink}
              >
                <YouTubeIcon className={classes.icons} fontSize="large" />
              </a>

              {/* <InstagramIcon className={classes.icons} fontSize="large"/> */}
              <a
                href="https://instagram.com/dhtradesman"
                target="_blank"
                rel="noreferrer"
                className={classes.alink}
              >
                <InstagramIcon className={classes.icons} fontSize="large" />
              </a>
              <a
                href="https://pinterest.com/dhtradesman"
                target="_blank"
                rel="noreferrer"
                className={classes.alink}
              >
                <PinterestIcon className={classes.icons} fontSize="large" />
              </a>
            </CardActions>
            <div className={classes.verseContainer}>
              <Typography variant="h8" align="center" gutterBottom>
                Psalm 90:17
              </Typography>
            </div>
          </div>
        </Grid>
        {/* </Box> */}
        {/* <Box clone order={{ xs: 2, sm: 2 }}>
          <Grid item md={4} xs={0}>
            <div align="center">
              <img
                src={LightLogo}
                className={classes.watermark}
                alt="logo image"
                fill="black"
                width="200"
              />
              <svg src={LightLogo} />
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 700.000000 700.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
                  fill="url(#gradient)"
                  fill={svgColor}
                  stroke="none"
                >
                  <path
                    d="M2695 6990 c-4 -6 -10 -8 -14 -6 -4 3 -160 -148 -347 -335 -186 -186
-343 -339 -349 -339 -5 0 -73 52 -150 116 -77 63 -152 122 -167 130 -42 22
-74 8 -118 -50 -21 -28 -275 -287 -564 -575 -289 -288 -523 -528 -520 -532 3
-5 0 -9 -5 -9 -8 0 -11 -151 -11 -489 l0 -489 -97 -11 c-54 -6 -144 -15 -201
-20 -64 -6 -113 -16 -128 -26 l-24 -15 0 -820 c0 -544 3 -821 10 -825 6 -4 8
-10 6 -14 -3 -4 148 -160 335 -347 186 -186 339 -343 339 -349 0 -5 -52 -73
-116 -150 -141 -171 -150 -187 -133 -226 6 -16 26 -39 43 -51 17 -12 273 -264
570 -560 296 -296 542 -535 547 -532 5 3 9 0 9 -5 0 -7 155 -12 487 -13 l487
-3 8 -45 c5 -25 14 -114 22 -198 10 -104 19 -160 30 -177 l16 -25 825 0 c574
0 825 3 825 11 0 5 4 8 8 5 5 -3 161 148 348 335 186 186 343 339 349 339 5 0
73 -52 150 -116 77 -63 152 -122 167 -130 38 -20 74 -9 106 34 15 20 269 279
565 574 296 296 535 543 532 548 -3 6 -1 10 4 10 7 0 12 155 13 487 l3 487 45
8 c25 5 114 15 198 22 103 10 161 20 178 30 l24 16 0 818 c0 623 -3 821 -12
830 -7 7 -8 12 -3 12 6 0 -145 155 -335 345 -316 317 -344 347 -332 365 6 11
63 83 126 159 63 77 117 149 121 160 8 26 -17 74 -52 96 -15 10 -270 261 -565
557 -296 297 -542 536 -548 533 -5 -3 -10 -1 -10 4 0 7 -155 12 -487 13 l-487
3 -8 45 c-5 25 -14 114 -22 198 -10 104 -19 160 -30 177 l-16 25 -820 0 c-544
0 -821 -3 -825 -10z m1523 -200 c1 -19 9 -102 18 -185 13 -124 20 -154 37
-172 11 -13 26 -23 33 -23 6 0 14 -7 18 -15 5 -13 70 -15 503 -15 l498 0 514
-514 c371 -372 511 -517 505 -527 -4 -8 -57 -75 -117 -149 l-109 -134 6 -56 7
-55 349 -350 350 -350 0 -727 0 -728 -22 -4 c-13 -2 -97 -12 -188 -21 -139
-14 -169 -20 -187 -38 -13 -11 -23 -26 -23 -33 0 -6 -7 -14 -15 -18 -13 -5
-15 -70 -15 -503 l0 -498 -515 -515 c-400 -400 -518 -513 -529 -505 -8 6 -74
59 -147 119 l-133 108 -56 -6 -55 -7 -350 -349 -350 -350 -730 2 -730 3 -3 35
c-1 19 -9 103 -18 185 -13 124 -20 154 -37 173 -11 12 -26 22 -33 22 -6 0 -14
7 -18 15 -5 13 -70 15 -503 15 l-498 0 -515 515 c-401 401 -513 518 -505 529
6 8 59 74 119 148 l108 133 -6 55 -7 55 -349 350 -350 350 2 730 3 730 40 3
c119 7 330 35 347 45 10 7 21 22 24 34 3 12 12 24 20 27 12 5 14 84 14 503 l0
498 512 512 c282 282 517 513 521 513 4 0 72 -52 149 -116 l142 -116 55 6 56
7 350 349 350 350 730 -2 730 -3 3 -35z"
                  ></path>
                  <path
                    d="M3390 6712 c-8 -4 -34 -19 -57 -34 -48 -31 -79 -35 -109 -13 -19 13
-24 11 -62 -25 -23 -22 -45 -40 -50 -40 -6 0 -17 16 -26 35 -9 19 -23 35 -30
35 -49 0 -213 -121 -174 -128 9 -2 33 6 54 17 47 26 61 26 68 4 4 -10 15 -29
25 -43 l19 -24 51 42 c43 36 53 41 75 33 32 -13 75 0 122 35 l37 28 16 -23
c52 -75 87 -87 147 -50 29 17 38 19 71 9 27 -9 73 -9 161 -3 125 10 182 5 239
-18 31 -12 34 -12 63 16 38 37 38 50 -2 72 -28 15 -52 17 -158 14 -233 -7
-226 -7 -249 13 -21 19 -22 19 -68 -14 -43 -31 -48 -32 -72 -19 -14 8 -34 31
-44 52 -19 38 -22 40 -47 29z"
                  ></path>
                  <path
                    d="M5220 6100 c-13 -9 -13 -11 0 -20 8 -5 34 -15 58 -22 36 -10 43 -16
39 -33 -20 -85 -20 -82 5 -88 12 -4 41 -7 64 -7 34 0 43 -4 52 -24 15 -33 45
-51 108 -66 l52 -11 -5 -63 -5 -63 34 -21 c20 -12 45 -22 57 -22 16 0 26 -10
36 -34 8 -19 38 -54 67 -78 108 -90 176 -160 194 -201 22 -51 30 -57 70 -57
50 0 60 21 35 73 -23 47 -72 99 -181 189 -49 41 -67 64 -76 94 -9 33 -15 39
-40 42 -92 8 -108 39 -69 133 7 18 -22 31 -96 43 -38 7 -75 39 -81 71 -3 16
-12 21 -53 23 -76 4 -77 5 -60 53 9 23 14 43 13 44 -2 1 -39 14 -83 29 -86 28
-112 31 -135 16z"
                  ></path>
                  <path
                    d="M1634 6079 c-44 -21 -97 -72 -186 -179 -41 -49 -64 -67 -94 -76 -33
-9 -39 -15 -42 -40 -8 -92 -39 -108 -133 -69 -18 7 -31 -22 -43 -96 -7 -38
-39 -75 -71 -81 -16 -3 -21 -12 -23 -53 -4 -76 -5 -77 -52 -60 l-41 15 -13
-33 c-44 -105 -56 -197 -27 -197 9 0 41 77 41 99 0 13 3 13 86 -6 24 -6 34 17
34 83 0 34 4 43 24 52 33 15 51 45 66 110 l12 53 37 -7 c20 -4 38 -6 41 -6 41
0 53 6 70 35 11 17 20 42 20 55 0 17 9 27 34 37 19 8 54 38 78 67 97 117 160
176 209 197 48 21 49 22 49 65 0 31 -5 46 -16 50 -20 8 -12 9 -60 -15z"
                  ></path>
                  <path
                    d="M1304 5307 c-2 -7 -3 -60 -2 -118 l3 -104 150 -8 c83 -4 184 -11 225
-15 l75 -7 3 -1101 c2 -940 0 -1103 -12 -1107 -8 -3 -96 -9 -195 -13 l-181 -7
0 -118 0 -119 118 0 c215 0 542 41 770 96 563 135 992 419 1187 787 54 101 80
173 104 287 l18 85 139 1 c76 0 145 -2 152 -4 9 -3 12 -47 12 -176 0 -94 3
-370 7 -613 l6 -443 120 0 119 0 -3 613 -3 612 534 -4 c376 -3 537 -7 542 -15
4 -6 8 -280 8 -608 l0 -598 120 0 120 0 0 603 -1 602 244 3 244 2 6 113 c3 61
3 115 0 120 -2 4 -105 7 -228 7 -123 0 -235 4 -249 10 l-26 10 0 590 0 591
-117 -3 -118 -3 -3 -593 -2 -594 -533 7 c-292 4 -535 9 -539 12 -5 2 -8 271
-8 596 0 326 -4 597 -8 604 -5 9 -38 10 -120 6 l-112 -6 0 -599 0 -599 -157 3
-157 3 -16 70 c-94 406 -469 764 -1006 961 -129 47 -251 81 -444 124 -93 20
-341 50 -495 60 -219 14 -284 13 -291 -3z m801 -308 c86 -16 287 -76 380 -112
347 -136 615 -347 747 -588 39 -70 75 -185 89 -281 32 -220 -69 -470 -270
-668 -175 -173 -465 -328 -766 -410 -51 -13 -264 -60 -276 -60 -5 0 -9 425 -9
1070 l0 1070 23 -4 c12 -3 49 -10 82 -17z"
                  ></path>
                  <path
                    d="M6540 4115 c0 -8 9 -32 20 -52 27 -50 25 -58 -10 -73 -55 -23 -57
-35 -11 -90 35 -42 40 -52 32 -74 -13 -32 0 -78 35 -124 l27 -35 -21 -16 c-12
-9 -33 -24 -47 -34 -31 -22 -33 -66 -4 -113 17 -29 19 -38 9 -71 -9 -27 -9
-73 -3 -161 10 -125 5 -182 -18 -239 -12 -31 -12 -34 16 -63 37 -38 50 -38 72
3 15 27 17 51 14 157 -7 233 -7 226 13 249 19 21 19 22 -14 68 -31 43 -32 48
-19 72 8 14 31 34 52 44 43 22 43 32 -4 102 -32 48 -36 80 -14 111 13 19 11
24 -26 63 -35 36 -39 44 -28 58 7 8 23 19 36 24 13 5 23 15 23 22 0 18 -56
125 -79 150 -25 30 -51 41 -51 22z"
                  ></path>
                  <path
                    d="M372 4047 c-27 -32 -35 -119 -23 -247 12 -127 10 -151 -17 -183 -14
-16 -12 -21 18 -64 31 -43 32 -48 19 -72 -8 -14 -31 -34 -52 -44 -43 -22 -43
-32 4 -102 33 -48 36 -75 14 -109 -15 -23 -14 -25 25 -65 46 -46 44 -59 -10
-81 -17 -7 -30 -14 -30 -16 0 -17 78 -145 103 -168 38 -36 45 -21 18 33 -26
49 -26 68 -3 75 9 4 28 15 41 25 l24 19 -39 47 c-35 44 -39 53 -36 96 3 41 -1
55 -29 95 l-32 48 22 15 c75 52 87 87 50 147 -18 30 -19 38 -9 70 9 27 9 67 1
167 -11 131 -8 164 20 234 12 31 11 34 -16 63 -31 33 -47 37 -63 17z"
                  ></path>
                  <path
                    d="M3210 2429 c-67 -27 -115 -124 -150 -302 -11 -53 -14 -58 -34 -53
-68 17 -158 -57 -189 -158 -12 -37 -22 -53 -31 -50 -7 3 -31 -13 -53 -36 -41
-40 -79 -52 -89 -27 -2 7 2 53 11 101 19 114 19 135 -2 143 -10 3 -26 13 -35
21 -27 23 -102 10 -151 -26 -113 -80 -152 -242 -75 -307 46 -38 100 -32 155
18 l23 20 24 -26 c42 -45 119 -33 175 27 31 33 36 33 51 -4 30 -73 145 -78
193 -10 13 19 14 19 42 -10 51 -53 130 -49 208 12 l38 30 21 -27 c58 -74 194
-72 289 5 l36 29 28 -29 c71 -74 257 -80 355 -10 38 27 46 25 54 -11 5 -27 9
-30 38 -27 30 3 37 11 80 91 57 105 98 167 98 147 0 -7 -7 -42 -16 -76 -8 -34
-14 -84 -12 -111 3 -45 5 -48 32 -48 26 0 33 9 85 106 31 59 61 115 68 125 22
35 23 7 3 -72 -11 -43 -20 -89 -20 -102 0 -30 42 -72 73 -72 59 0 186 91 174
124 -10 25 -31 19 -83 -24 -90 -74 -114 -37 -70 105 30 96 33 140 10 149 -55
21 -117 -22 -164 -113 -33 -63 -34 -61 -20 24 12 76 7 95 -29 95 -39 0 -101
-64 -139 -141 -17 -33 -32 -57 -35 -52 -3 5 3 47 13 94 19 86 16 104 -16 97
-25 -4 -43 -44 -58 -125 -7 -41 -18 -68 -26 -71 -8 -3 -34 -22 -57 -43 -53
-49 -70 -50 -65 -6 3 27 -5 47 -43 101 -41 61 -46 72 -40 106 5 32 3 40 -14
50 -35 18 -58 -4 -107 -103 -64 -126 -74 -140 -90 -126 -10 8 -21 4 -47 -15
-71 -54 -160 -72 -205 -40 -12 8 -22 18 -22 22 0 4 24 16 53 26 76 26 113 52
131 90 23 48 20 71 -12 107 -23 26 -35 31 -74 31 -25 0 -60 -8 -77 -17 -41
-21 -85 -82 -101 -141 -20 -70 -102 -139 -158 -132 -22 2 -30 11 -41 46 l-13
43 58 87 c120 181 166 282 168 379 1 48 -2 58 -27 79 -30 25 -56 29 -97 13z
m48 -122 c4 -46 -26 -130 -79 -219 -42 -71 -64 -88 -55 -40 3 15 8 50 12 77 4
28 15 79 26 115 32 106 90 146 96 67z m-646 -323 c-6 -63 -44 -153 -73 -179
-36 -29 -51 -31 -74 -8 -40 39 13 156 90 200 49 28 61 25 57 -13z m902 20 c23
-9 20 -47 -6 -71 -29 -27 -99 -56 -110 -45 -12 12 32 91 61 107 30 16 34 17
55 9z m-477 -63 c-12 -115 -56 -178 -106 -152 -17 9 -21 21 -21 57 0 80 55
154 114 154 17 0 18 -6 13 -59z m833 -41 c22 -44 26 -100 8 -118 -16 -16 -69
-15 -92 3 -19 15 -19 17 14 85 19 39 37 70 42 70 4 0 17 -18 28 -40z"
                  ></path>
                  <path
                    d="M1610 2420 c-83 -10 -137 -27 -175 -53 -41 -29 -52 -43 -82 -105 -45
-96 -5 -112 69 -28 57 65 102 83 233 91 122 8 126 4 87 -84 -62 -138 -106
-294 -123 -436 -17 -135 -1 -185 56 -185 40 0 52 34 59 160 8 148 32 266 101
488 l16 52 159 0 c167 0 205 7 216 43 12 37 -16 44 -219 51 -105 3 -223 8
-262 10 -38 2 -99 0 -135 -4z"
                  ></path>
                  <path
                    d="M4875 2066 c-38 -17 -112 -97 -131 -142 -17 -41 -20 -119 -6 -155 28
-71 123 -78 191 -16 17 16 25 18 28 9 14 -39 71 -54 125 -33 40 16 88 71 88
102 0 44 -17 44 -65 0 -44 -40 -80 -52 -87 -30 -2 7 4 59 13 117 18 114 17
132 -11 132 -10 0 -23 7 -30 15 -15 18 -74 19 -115 1z m95 -64 c0 -29 -37
-148 -54 -174 -22 -34 -62 -51 -87 -38 -23 13 -26 77 -5 118 26 49 99 108 139
111 4 1 7 -7 7 -17z"
                  ></path>
                  <path
                    d="M5445 2066 c-32 -14 -124 -106 -144 -144 -24 -45 -28 -20 -10 53 11
42 17 80 14 85 -4 6 -17 10 -31 10 -31 0 -47 -36 -74 -161 -21 -95 -16 -173
11 -190 26 -16 37 -8 73 56 35 62 127 185 138 185 12 0 10 -24 -6 -72 -33
-102 -30 -148 11 -167 53 -24 203 49 203 100 0 33 -27 33 -72 0 -38 -28 -88
-42 -88 -23 0 4 14 50 30 102 38 121 39 157 4 170 -14 6 -26 10 -27 10 -1 -1
-15 -7 -32 -14z"
                  ></path>
                  <path
                    d="M2017 2046 c-18 -27 -47 -179 -47 -248 0 -47 24 -88 50 -88 14 0 50
37 50 51 0 19 92 209 100 204 4 -2 5 -17 2 -33 -2 -17 1 -39 7 -51 17 -31 91
-29 148 4 44 26 50 38 33 65 -8 12 -14 12 -45 -3 -38 -18 -71 -22 -79 -9 -2 4
2 29 11 55 17 52 8 77 -29 77 -35 0 -56 -19 -107 -97 -54 -81 -61 -78 -36 18
9 33 13 64 10 69 -12 19 -53 10 -68 -14z"
                  ></path>
                  <path
                    d="M6066 1750 c-9 -22 -16 -48 -16 -56 0 -13 -6 -15 -27 -10 -76 19 -80
19 -86 -6 -4 -12 -7 -41 -7 -64 0 -34 -4 -43 -24 -52 -33 -15 -51 -45 -66
-110 l-12 -53 -37 7 c-40 7 -37 7 -68 5 -24 -1 -63 -56 -63 -90 0 -16 -10 -26
-34 -36 -19 -8 -54 -38 -78 -67 -90 -108 -160 -176 -201 -194 -23 -10 -45 -23
-49 -29 -13 -17 -9 -83 5 -87 45 -17 120 42 257 200 41 48 64 66 90 71 30 6
35 11 38 36 8 93 38 109 133 70 18 -7 31 22 43 96 7 38 39 75 71 81 16 3 21
12 23 53 4 76 5 77 52 60 l41 -15 13 33 c31 74 49 146 42 171 -9 37 -21 32
-40 -14z"
                  ></path>
                  <path
                    d="M906 1694 c-16 -43 50 -125 206 -256 42 -35 58 -57 65 -85 7 -32 13
-38 38 -41 86 -8 105 -33 80 -104 -17 -50 -14 -53 67 -69 59 -12 93 -37 100
-74 3 -16 12 -21 53 -23 76 -4 77 -5 60 -52 l-15 -41 33 -13 c106 -44 197 -56
197 -27 0 10 -73 41 -96 41 -17 0 -17 0 3 86 6 24 -17 34 -83 34 -34 0 -43 4
-52 24 -15 33 -45 51 -110 66 l-53 12 7 37 c7 40 7 37 5 68 -1 24 -56 63 -90
63 -16 0 -26 10 -36 34 -8 19 -38 54 -67 78 -108 90 -176 160 -194 201 -23 52
-29 57 -75 57 -25 0 -39 -5 -43 -16z"
                  ></path>
                  <path
                    d="M3299 1481 c-17 -17 -29 -40 -29 -55 0 -23 -3 -25 -30 -19 -19 3 -30
1 -30 -6 0 -6 14 -14 30 -17 26 -6 30 -11 30 -40 0 -18 -4 -44 -9 -57 -9 -23
-12 -24 -49 -14 -50 13 -72 5 -72 -28 0 -36 39 -53 85 -36 30 11 39 9 82 -13
72 -37 99 -41 131 -20 15 10 43 24 62 31 32 12 41 10 104 -18 74 -34 117 -33
124 5 4 17 2 17 -21 1 -24 -15 -28 -15 -76 5 -70 31 -73 35 -57 111 l13 64 43
6 c44 6 90 44 90 75 0 26 -38 54 -74 54 -42 0 -76 -27 -92 -71 -8 -26 -16 -33
-32 -31 -33 5 -34 -15 -1 -27 31 -11 31 -12 24 -58 -4 -27 -9 -51 -11 -54 -2
-4 -21 -2 -42 4 -22 6 -46 7 -55 4 -19 -7 -23 -47 -6 -64 8 -8 5 -14 -11 -23
-18 -10 -31 -7 -78 17 -62 30 -60 27 -45 118 8 50 8 50 52 56 31 4 51 14 68
33 28 33 29 50 3 76 -31 31 -85 27 -121 -9z m105 -17 c13 -34 -25 -64 -80 -64
-26 0 -31 18 -13 51 19 36 81 45 93 13z m267 16 c23 -13 25 -43 4 -60 -19 -16
-95 -26 -95 -12 0 27 22 63 42 72 30 12 27 11 49 0z m-466 -230 c31 -12 24
-30 -11 -30 -17 0 -24 5 -24 20 0 23 0 23 35 10z m296 -15 c0 -16 -30 -18 -47
-4 -11 9 -12 14 -3 20 15 9 51 -3 50 -16z"
                  ></path>
                  <path
                    d="M3793 1482 c-86 -47 -122 -176 -67 -241 22 -27 33 -31 72 -31 51 0
104 26 122 59 15 29 -3 27 -35 -3 -30 -28 -74 -41 -105 -31 -24 8 -50 54 -50
90 0 65 60 145 110 145 58 0 61 -48 6 -78 -31 -16 -31 -16 -6 -20 17 -3 31 4
47 23 60 69 -8 133 -94 87z"
                  ></path>
                  <path
                    d="M3899 459 c-41 -34 -50 -38 -72 -30 -33 13 -79 0 -125 -35 l-35 -28
-16 23 c-52 75 -87 87 -147 50 -29 -17 -38 -19 -71 -9 -27 9 -73 9 -161 3
-125 -10 -182 -5 -239 18 -31 12 -34 12 -63 -16 -38 -37 -38 -50 3 -72 27 -15
51 -17 157 -14 233 7 226 7 249 -13 21 -19 22 -19 68 14 43 31 48 32 72 19 14
-8 34 -31 44 -52 22 -43 32 -43 102 4 48 32 80 36 111 14 19 -13 24 -11 63 26
36 35 44 39 58 28 8 -7 19 -23 24 -36 11 -30 25 -29 95 8 69 35 128 92 102 97
-9 2 -33 -6 -54 -17 -21 -12 -43 -21 -49 -21 -5 0 -20 18 -33 40 -12 22 -26
40 -30 40 -4 -1 -28 -19 -53 -41z"
                  ></path>
                </g>
              </svg>
              <br />
              <Typography variant="h8" align="center" gutterBottom>
                Work Smarter. And Harder.
              </Typography>
            </div>
          </Grid>
        </Box> */}
      </Grid>
    </footer>
  );
};

export default Footer;
